import { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import ContactMap from "../sub-map/ContactMap";

function DirectionsEn() {
  useEffect(() => {
    const { naver } = window;
    var mapOptions = {
      center: new naver.maps.LatLng(35.2314452, 126.863507),
      zoom: 30,
    };
    var map = new naver.maps.Map("map", mapOptions);

    return () => {
      window.location.reload();
    };
  }, []);

  return (
    <div className="Contact Directions">
      <ContactMap tag2={"Directions"}></ContactMap>
      <div className="sub-con">
        <div className="section1">
          <div className="container">
            <h3 className="h3-st2">Directions</h3>
            <div className="map-wrap">
              <div id="map"></div>
            </div>
            <ul className="flex-wrap">
              <li>
                <span className="icon">
                  <i className="xi-call"></i>
                </span>
                <h4>Contact</h4>
                <p>1899-5397</p>
              </li>
              <li>
                <span className="icon">
                  <i className="xi-maker"></i>
                </span>
                <h4>Headquarters Address</h4>
                <p>
                  3F, Yongbi Building, 1 Yongbong-ro, Bukgu, Gwangju, Republic
                  of Korea
                </p>
              </li>
              <li>
                <span className="icon">
                  <i className="xi-mail"></i>
                </span>
                <h4>E-mail</h4>
                <p>contact@bio3s.com</p>
              </li>
            </ul>
          </div>
        </div>
        <div className="section2">
          <div className="container">
            <h3 className="h3-st1">Locations</h3>
            <ul className="flex-wrap">
              <li>
                <div className="img-wrap">
                  <img src={require("../../images/com-icon-01.png")} alt="" />
                </div>
                <div className="txt-wrap">
                  <p>Headquarters and Biomaterial Production Facility</p>
                  <p>
                    102, Agribusiness Incubator Center, 77 Yongbongro, Bukgu,
                    Gwangju, Republic of Korea
                  </p>
                </div>
                <button
                  onClick={() =>
                    window.open(
                      "https://map.naver.com/p/entry/place/1214139192?placePath=%2Fhome&c=15.00,0,0,0,dh",
                      "_blank"
                    )
                  }
                >
                  View Map
                </button>
              </li>
              <li>
                <div className="img-wrap">
                  <img src={require("../../images/com-icon-03.png")} alt="" />
                </div>
                <div className="txt-wrap">
                  <p>Medical device sales facility</p>
                  <p>
                    3F, Yongbi Building, 1 Yongbong-ro, Bukgu, Gwangju, Republic
                    of Korea
                  </p>
                </div>
                <button
                  onClick={() =>
                    window.open(
                      "https://map.naver.com/v5/search/%EA%B4%91%EC%A3%BC%EA%B4%91%EC%97%AD%EC%8B%9C%20%EB%B6%81%EA%B5%AC%20%EC%B2%A8%EB%8B%A8%EB%B2%A4%EC%B2%98%EC%86%8C%EB%A1%9C%2062%EB%B2%88%EA%B8%B8%2030/address/14122376.212750759,4195377.973604299,%EA%B4%91%EC%A3%BC%EA%B4%91%EC%97%AD%EC%8B%9C%20%EB%B6%81%EA%B5%AC%20%EC%B2%A8%EB%8B%A8%EB%B2%A4%EC%B2%98%EC%86%8C%EB%A1%9C62%EB%B2%88%EA%B8%B8%2030,new?c=14122348.7057046,4195378.6413890,19,0,0,0,dh&isCorrectAnswer=true",
                      "_blank"
                    )
                  }
                >
                  View Map
                </button>
              </li>
              <li>
                <div className="img-wrap">
                  <img src={require("../../images/com-icon-05.png")} alt="" />
                </div>
                <div className="txt-wrap">
                  <p>
                    Over-the-counter (OTC) pharmaceutical sales business /<br />{" "}
                    Cosmetics manufacturing facility
                  </p>
                  <p>
                    30, Cheomdan venture so-ro 62beon-gil, Buk-gu, Gwangju,
                    Republic of Korea
                  </p>
                </div>
                <button
                  onClick={() =>
                    window.open(
                      "https://map.naver.com/p/search/%EA%B4%91%EC%A3%BC%EA%B4%91%EC%97%AD%EC%8B%9C%20%EB%B6%81%EA%B5%AC%20%EC%B2%A8%EB%8B%A8%EB%B2%A4%EC%B2%98%EC%86%8C%EB%A1%9C%2062%EB%B2%88%EA%B8%B8%2030/address/14122376.2127508,4195377.9736043,%EA%B4%91%EC%A3%BC%EA%B4%91%EC%97%AD%EC%8B%9C%20%EB%B6%81%EA%B5%AC%20%EC%B2%A8%EB%8B%A8%EB%B2%A4%EC%B2%98%EC%86%8C%EB%A1%9C62%EB%B2%88%EA%B8%B8%2030,new?c=19.00,0,0,0,dh&isCorrectAnswer=true",
                      "_blank"
                    )
                  }
                >
                  View Map
                </button>
              </li>
              <li>
                <div className="img-wrap">
                  <img src={require("../../images/com-icon-04.png")} alt="" />
                </div>
                <div className="txt-wrap">
                  <p>Company-affiliated research institute</p>
                  <p>
                    30, Cheomdan venture so-ro 62beon-gil, Buk-gu, Gwangju,
                    Republic of Korea
                  </p>
                </div>
                <button
                  onClick={() =>
                    window.open(
                      "https://map.naver.com/p/search/%EA%B4%91%EC%A3%BC%EA%B4%91%EC%97%AD%EC%8B%9C%20%EB%B6%81%EA%B5%AC%20%EC%B2%A8%EB%8B%A8%EB%B2%A4%EC%B2%98%EC%86%8C%EB%A1%9C%2062%EB%B2%88%EA%B8%B8%2030/address/14122376.2127508,4195377.9736043,%EA%B4%91%EC%A3%BC%EA%B4%91%EC%97%AD%EC%8B%9C%20%EB%B6%81%EA%B5%AC%20%EC%B2%A8%EB%8B%A8%EB%B2%A4%EC%B2%98%EC%86%8C%EB%A1%9C62%EB%B2%88%EA%B8%B8%2030,new?c=19.00,0,0,0,dh&isCorrectAnswer=true",
                      "_blank"
                    )
                  }
                >
                  View Map
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DirectionsEn;
